// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__10kxo","header":"PatientQuestionnaire_header__2ASkY","info":"PatientQuestionnaire_info__2df2t"};